module.exports = __webpack_public_path__ + "static/media/NIFTYMETAL.5d128c49.txt";